(() => {
  function setup(root) {
    if (root.dataset.discoveryReady) return;
    root.dataset.discoveryReady = 'true';
    const panel = root.querySelector('[data-refine-panel]');
    const openButton = root.querySelector('[data-open-refine]');
    const mobile = matchMedia('(max-width: 999px)');
    let previousFocus = null;
    let previousOverflow = '';
    let opened = false;
    function open() {
      if (!mobile.matches || opened || !panel || !openButton) return;
      previousFocus = document.activeElement;
      previousOverflow = document.body.style.overflow;
      opened = true;
      root.classList.add('is-refining');
      openButton.setAttribute('aria-expanded', 'true');
      panel.setAttribute('role', 'dialog');
      panel.setAttribute('aria-modal', 'true');
      document.body.style.overflow = 'hidden';
      panel.querySelector('[data-close-refine]')?.focus();
    }
    function close() {
      root.classList.remove('is-refining');
      openButton?.setAttribute('aria-expanded', 'false');
      panel?.removeAttribute('role');
      panel?.removeAttribute('aria-modal');
      if (opened) document.body.style.overflow = previousOverflow;
      opened = false;
      if (previousFocus?.isConnected) previousFocus.focus();
      previousFocus = null;
    }
    if (panel && openButton) {
      root.classList.add('pulse-discovery--enhanced');
      openButton.hidden = false;
      root.querySelectorAll('[data-close-refine]').forEach(button => {
        button.hidden = false;
        button.addEventListener('click', close);
      });
      openButton.addEventListener('click', open);
      panel.addEventListener('keydown', event => {
        if (!opened) return;
        if (event.key === 'Escape') { event.preventDefault(); close(); }
        if (event.key !== 'Tab') return;
        const controls = [...panel.querySelectorAll('a[href],button,input,select,summary,[tabindex="0"]')].filter(node => !node.disabled && node.getClientRects().length);
        const first = controls[0], last = controls[controls.length - 1];
        if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last?.focus(); }
        else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first?.focus(); }
      });
      mobile.addEventListener('change', () => { if (!mobile.matches) close(); });
    }
    root.querySelectorAll('[data-find-options]').forEach(input => {
      input.closest('[data-find-wrapper]').hidden = false;
      input.addEventListener('input', () => {
        const group = input.closest('[data-refine-group]');
        const term = input.value.trim().toLocaleLowerCase();
        let visible = 0;
        group.querySelectorAll('[data-refine-value]').forEach(option => {
          option.hidden = !option.dataset.label.toLocaleLowerCase().includes(term);
          if (!option.hidden) visible++;
        });
        const empty = group.querySelector('[data-no-matches]');
        if (empty) empty.hidden = visible !== 0;
      });
    });
    // Native GET requests retain every checked refinement and the selected sort.
    // Only option-list search runs locally; products always come from Shopify.
    root.querySelector('.pulse-refine__form')?.addEventListener('invalid', event => {
      const group = event.target.closest('details');
      if (group) group.open = true;
      open();
    }, true);
    root.querySelector('.pulse-refine__form')?.addEventListener('submit', event => {
      const inputs = [...event.currentTarget.querySelectorAll('input[type="number"]')];
      inputs.forEach(input => input.setCustomValidity(''));
      for (let index = 0; index + 1 < inputs.length; index += 2) {
        const [minimum, maximum] = inputs.slice(index, index + 2);
        if (minimum.value !== '' && maximum.value !== '' && Number(minimum.value) > Number(maximum.value)) {
          maximum.setCustomValidity('Choose a maximum price that is at least the minimum.');
          event.preventDefault();
          maximum.closest('details').open = true;
          open();
          maximum.reportValidity();
        }
      }
    });
    root.querySelectorAll('input[type="number"]').forEach(input => input.addEventListener('input', () => root.querySelectorAll('input[type="number"]').forEach(field => field.setCustomValidity(''))));
  }
  document.querySelectorAll('[data-pulse-discovery]').forEach(setup);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-pulse-discovery]').forEach(setup));
})();
